import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

/**
 * تلميح جميل بديل عن title الافتراضي
 * يظهر عند التحويم ويُغلق بزر X أو عند إبعاد المؤشر
 */
export default function Tooltip({ content, children, position = "top" }) {
  const [visible, setVisible] = useState(false);
  const hideTimer = useRef(null);
  const wrapRef = useRef(null);

  const show = () => {
    clearTimeout(hideTimer.current);
    setVisible(true);
  };

  const hide = () => {
    clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setVisible(false), 120);
  };

  const dismiss = (e) => {
    e.stopPropagation();
    clearTimeout(hideTimer.current);
    setVisible(false);
  };

  useEffect(() => {
    return () => clearTimeout(hideTimer.current);
  }, []);

  if (!content) return children;

  return (
    <span
      ref={wrapRef}
      className="pretty-tooltip-wrap"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      {children}
      {visible && (
        <span
          className={`pretty-tooltip pretty-tooltip--${position}`}
          role="tooltip"
          onMouseEnter={show}
          onMouseLeave={hide}
        >
          <span className="pretty-tooltip__text">{content}</span>
          <button
            type="button"
            className="pretty-tooltip__close"
            onClick={dismiss}
            aria-label="إغلاق التلميح"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
          <span className="pretty-tooltip__arrow" />
        </span>
      )}
      <style>{`
        .pretty-tooltip-wrap {
          position: relative;
          display: inline-flex;
        }
        .pretty-tooltip {
          position: absolute;
          z-index: 9999;
          display: flex;
          align-items: center;
          gap: 8px;
          background: #dbeafe;
          color: #1e3a5f;
          font-size: 13px;
          font-family: 'Cairo', sans-serif;
          font-weight: 400;
          padding: 8px 12px;
          border-radius: 6px;
          box-shadow: 0 4px 16px rgba(30, 58, 95, 0.18);
          white-space: nowrap;
          pointer-events: auto;
          animation: pretty-tooltip-in 0.15s ease;
        }
        @keyframes pretty-tooltip-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .pretty-tooltip--top {
          bottom: calc(100% + 10px);
          right: 50%;
          transform: translateX(50%);
        }
        .pretty-tooltip--bottom {
          top: calc(100% + 10px);
          right: 50%;
          transform: translateX(50%);
        }
        .pretty-tooltip__text {
          line-height: 1.5;
        }
        .pretty-tooltip__close {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          border: 1px solid rgba(30, 58, 95, 0.25);
          background: transparent;
          border-radius: 50%;
          color: #1e3a5f;
          font-size: 10px;
          cursor: pointer;
          flex-shrink: 0;
          padding: 0;
        }
        .pretty-tooltip__close:hover {
          background: rgba(30, 58, 95, 0.12);
        }
        .pretty-tooltip__arrow {
          position: absolute;
          width: 10px;
          height: 10px;
          background: #dbeafe;
          transform: rotate(45deg);
        }
        .pretty-tooltip--top .pretty-tooltip__arrow {
          top: 100%;
          right: 50%;
          margin-top: -5px;
          margin-right: -5px;
        }
        .pretty-tooltip--bottom .pretty-tooltip__arrow {
          bottom: 100%;
          right: 50%;
          margin-bottom: -5px;
          margin-right: -5px;
        }
      `}</style>
    </span>
  );
}
